// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropDownModal-web-keyboard {
  background-color: #fff;
  z-index: 1;
  overflow: scroll;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
  outline: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 10px 10px 10px 10px;
  height: calc(100vh - 1.5rem);
  overflow: scroll;
}

.dark .DropDownModal-web-keyboard {
  background-color: var(--dark-blue);
  color: rgb(255, 255, 255) !important;
}

.search-bar-no-result {
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

/* ── Unified empty / default state ────────────────────────── */
.kbd-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 48px 32px;
  text-align: center;
  width: 100%;
  flex: 1;
}

.kbd-empty-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}
.kbd-empty-icon--scan {
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  color: #2a71ff;
  box-shadow: 0 6px 24px rgba(42, 113, 255, 0.15);
}
.kbd-empty-icon--search {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  color: #94a3b8;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
}

.kbd-empty-heading {
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.01em;
}
.kbd-empty-sub {
  font-size: 12.5px;
  color: #94a3b8;
  margin: 0;
  max-width: 260px;
}

.kbd-empty-hints {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  margin-top: 6px;
}
.kbd-empty-hint-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 11.5px;
  font-weight: 600;
  color: #475569;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
}

/* dark mode */
.dark .kbd-empty-icon--scan  { background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%); color: #93c5fd; }
.dark .kbd-empty-icon--search { background: #1e293b; color: #475569; }
.dark .kbd-empty-heading { color: #e2e8f0; }
.dark .kbd-empty-sub    { color: #475569; }
.dark .kbd-empty-hint-chip { background: #1e293b; border-color: #334155; color: #64748b; }

.dark .drop-down-modal-bg {
  padding: 0 !important;
  background-color: var(--dark-blue);
}


.drop-down-modal-bg {
  padding: 0 !important;
}

.popular-search-head {
  font-weight: bold;
  background-color: white !important;
}

.dark .popular-search-head {
  background-color: var(--dark-blue) !important;
}

.recent-search-inner-details {
  text-align: left !important;
  font-size: 0.9rem !important;
  overflow-wrap: break-word;
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.5s ease;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recent-search-mrp {
  font-size: 1rem !important;
  font-weight: bold !important;
}

.info-icon-box {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 1rem;
  margin-right: 1rem !important;
  height: 30px;
  gap: 1rem;
  align-items: center;
  margin-top: 10px;
}

.popular-search-reult-found {
  color: #0563fb;
  font-size: 1.3rem !important;
  font-weight: bold !important;
}

/* ── Top Searches ── */
.top-searches-title {
  font-size: 13px;
  font-weight: 700;
  color: #2a71ff;
  margin-bottom: 14px;
  text-align: left;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

/* Horizontal scrolling row */
.top-searches-container {
  display: flex;
  flex-direction: row;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 8px;
  scrollbar-width: none;
}
.top-searches-container::-webkit-scrollbar {
  display: none;
}

/* Image-first card */
.top-search-card {
  flex: 0 0 128px;
  width: 128px;
  border-radius: 18px;
  border: 1px solid #e2e8f0;
  background-color: #ffffff;
  padding: 14px 10px 12px;
  text-align: center;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.06);
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}
.dark .top-search-card {
  background-color: var(--dark-blue);
  border-color: #334155;
}
.top-search-card:hover,
.top-search-card:focus {
  transform: translateY(-3px);
  box-shadow: 0 12px 28px rgba(42, 113, 255, 0.14);
  border-color: rgba(42, 113, 255, 0.4);
  outline: none;
}
.top-search-card:disabled {
  opacity: 0.7;
  cursor: wait;
  transform: none;
}

/* Image wrapper (circle) */
.top-search-card-img-wrap {
  position: relative;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;
  border: 2px solid #e2e8f0;
  flex-shrink: 0;
  background: #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
}
.top-search-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.top-search-card-avatar {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  font-weight: 800;
  border-radius: 50%;
}
.top-search-card-loader-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
  border-radius: 50%;
}

/* Product name */
.top-search-card-title {
  font-size: 11px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
  width: 100%;
}
.dark .top-search-card-title {
  color: #f1f5f9;
}

/* Price row */
.top-search-card-price {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  width: 100%;
}
.top-search-card-mrp {
  font-size: 10px;
  color: #94a3b8;
  text-decoration: line-through;
}
.dark .top-search-card-mrp {
  color: #64748b;
}
.top-search-card-sp {
  font-size: 12px;
  color: #2a71ff;
  font-weight: 700;
}

.drawer-dropdown-override {
  background-color: transparent !important;
  box-shadow: none !important;
  height: auto !important;
  overflow: visible !important;
  padding: 0;
  border-radius: 0;
  width: 100% !important;
  display: block !important;
}

.dark .drawer-dropdown-override {
  background-color: transparent !important;
}

/* Product Search Results Styles */
.product-search-results-heading {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #2a71ff;
}

.product-search-results-info-icon {
  display: flex;
  height: 20px;
  width: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: #dbeafe;
  color: #2a71ff;
  font-size: 11px;
}

.product-search-results-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.product-search-card {
  display: flex;
  align-items: center;
  gap: 16px;
  border-radius: 22px;
  border: 1px solid #e2e8f0;
  padding: 12px 16px;
  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.05);
  transition: all 0.2s ease;
  background-color: white;
  width: 100%;
  box-sizing: border-box;
}

.product-search-card:hover {
  border-color: #cbd5e1;
}

/* Highlight the whole row when its ADD button is keyboard-focused */
.product-search-card:has(.product-search-add-btn:focus-visible) {
  border-color: #2a71ff;
  background-color: #f0f5ff;
  box-shadow: 0 0 0 2px rgba(42, 113, 255, 0.15);
}

/* For products without inventory */
.product-search-card.scale-card {
  border-color: #fecdd3;
  background-color: rgba(254, 242, 242, 0.7);
}

/* ── Clickable area (image + details) in search results — opens product detail drawer ── */
.ps-clickable-body {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
  min-width: 0;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  border-radius: 12px;
  transition: background 0.15s;
}
.ps-clickable-body:hover {
  background: rgba(42, 113, 255, 0.06);
}
.ps-clickable-body:hover .product-search-name {
  color: #2a71ff;
}
.ps-clickable-body:focus-visible {
  outline: 2px solid #2a71ff;
  outline-offset: 2px;
}
.dark .ps-clickable-body:hover {
  background: rgba(42, 113, 255, 0.1);
}

.product-search-image-container {
  height: 56px;
  width: 56px;
  flex-shrink: 0;
  overflow: hidden;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background-color: #f8fafc;
}

.product-search-image {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.product-search-details {
  min-width: 0;
  flex: 1;
  text-align: left;
}

.product-search-title-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.product-search-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.dark .product-search-name {
  color: #f1f5f9;
}

/* Out-of-stock but eligible to sell */
.product-search-badge-oos {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 9999px;
  background-color: #fff7ed;
  border: 1px solid #fed7aa;
  padding: 4px 8px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #c2410c;
  line-height: 1;
  white-space: nowrap;
}
.dark .product-search-badge-oos {
  background-color: #431407;
  border-color: #7c2d12;
  color: #fb923c;
}

.product-search-badge-batches {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 9999px;
  background-color: #d1fae5;
  padding: 4px 8px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: #065f46;
  line-height: 1;
  white-space: nowrap;
}

.dark .product-search-badge-batches {
  background-color: #064e3b;
  color: #6ee7b7;
}

.product-search-badge-scale {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  border-radius: 9999px;
  background-color: #eff6ff;
  padding: 4px 8px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #2a71ff;
  line-height: 1;
}

.product-search-badge-weight-unit {
  display: inline-flex;
  align-items: center;
  border-radius: 9999px;
  background-color: #ecfdf5;
  padding: 4px 8px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.16em;
  color: #059669;
  line-height: 1;
}

.dark .product-search-badge-weight-unit {
  background-color: #064e3b;
  color: #6ee7b7;
}

.product-search-scale-icon {
  height: 12px;
  width: 12px;
}

.product-search-barcode {
  margin-top: 4px;
  font-size: 11px;
  font-weight: 500;
  color: #2a71ff;
  margin-bottom: 0;
}

.product-search-price-col {
  min-width: 72px;
  text-align: right;
}

.product-search-price {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  margin: 0;
}

.product-search-mrp {
  font-size: 12px;
  color: #64748b;
  font-weight: 500;
}

.product-search-sp {
  font-size: 14px;
  font-weight: 600;
  color: #2a71ff;
}

.product-search-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  min-height: 36px;
  height: 40px;
  border-radius: 12px;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
  color: white;
  cursor: pointer;
  background-color: #2a71ff;
  box-shadow: 0 14px 24px rgba(42, 113, 255, 0.24);
  outline: none;
}

.product-search-add-btn:hover {
  background-color: #1f63ea;
}

/* Keyboard-focus ring — visible only when navigating with Tab, not on mouse click */
.product-search-add-btn:focus-visible {
  background-color: #1a5ce0;
  outline: 2.5px solid #ffffff;
  outline-offset: 2px;
  box-shadow:
    0 0 0 5px rgba(42, 113, 255, 0.45),
    0 14px 24px rgba(42, 113, 255, 0.28);
  transform: scale(1.04);
}

.product-search-add-btn.scale-btn {
  background-color: #e11d48;
  box-shadow: 0 14px 24px rgba(225, 29, 72, 0.24);
}

.product-search-add-btn.scale-btn:hover,
.product-search-add-btn.scale-btn:focus {
  background-color: #be123c;
}

/* No-inventory button — muted, non-interactive */
.product-search-add-btn.no-inventory-btn {
  background-color: #f1f5f9;
  color: #94a3b8;
  box-shadow: none;
  cursor: not-allowed;
  border: 1.5px solid #e2e8f0;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  letter-spacing: 0.08em;
}
.product-search-add-btn.no-inventory-btn:hover,
.product-search-add-btn.no-inventory-btn:focus {
  background-color: #f1f5f9;
  color: #94a3b8;
}

/* No-inventory badge in title row */
.product-search-badge-no-inventory {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  border-radius: 9999px;
  background-color: #fef2f2;
  padding: 3px 8px;
  font-size: 9.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #dc2626;
  border: 1px solid #fecaca;
  line-height: 1;
}

/* Discounted price styles */
.product-search-mrp--disc {
  text-decoration: line-through;
  color: #94a3b8;
  font-size: 11px;
}
.product-search-sp--highlight {
  font-size: 15px;
  font-weight: 700;
  color: #16a34a;
}

/* Avatar letter for products without image */
.ps-avatar-letter {
  font-size: 22px;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1;
  user-select: none;
}

/* Dark mode additions */
.dark .product-search-badge-no-inventory {
  background-color: rgba(220, 38, 38, 0.12);
  border-color: rgba(220, 38, 38, 0.3);
  color: #f87171;
}
.dark .product-search-add-btn.no-inventory-btn {
  background-color: #1e293b;
  color: #475569;
  border-color: #334155;
}
.dark .product-search-sp--highlight { color: #4ade80; }

.dark .product-search-card {
  background-color: var(--dark-blue);
  border-color: #334155;
}

.dark .product-search-card.scale-card {
  background-color: rgba(244, 63, 94, 0.1);
  border-color: #fb7185;
}

.dark .product-search-card:hover,
.dark .product-search-card:focus-within {
  border-color: #475569;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/keyboardDropDownModal/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,UAAU;EACV,gBAAgB;EAChB,sFAAsF;EACtF,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;EAClC,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,gEAAgE;AAChE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,6DAA6D;EAC7D,cAAc;EACd,+CAA+C;AACjD;AACA;EACE,6DAA6D;EAC7D,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,cAAc;AACd,+BAA+B,6DAA6D,EAAE,cAAc,EAAE;AAC9G,gCAAgC,mBAAmB,EAAE,cAAc,EAAE;AACrE,2BAA2B,cAAc,EAAE;AAC3C,0BAA0B,cAAc,EAAE;AAC1C,6BAA6B,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;;AAEzF;EACE,qBAAqB;EACrB,kCAAkC;AACpC;;;AAGA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,6BAA6B;EAC7B,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;EAClB,6CAA6C;EAC7C,2EAA2E;EAC3E,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,kCAAkC;EAClC,qBAAqB;AACvB;AACA;;EAEE,2BAA2B;EAC3B,gDAAgD;EAChD,qCAAqC;EACrC,aAAa;AACf;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;AACA;EACE,eAAe;EACf,cAAc;EACd,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,uBAAuB;EACvB,4BAA4B;EAC5B,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,yBAAyB;EACzB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;EACE,qBAAqB;EACrB,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA,2FAA2F;AAC3F;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,eAAe;EACf,wCAAwC;EACxC,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oFAAoF;AACpF;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,mBAAmB;EACnB;;wCAEsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA,iDAAiD;AACjD;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,sBAAsB;AACxB;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,6BAA6B;EAC7B,cAAc;EACd,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,6CAA6C;AAC7C;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,iBAAiB;AACnB;;AAEA,wBAAwB;AACxB;EACE,yCAAyC;EACzC,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;AACA,sCAAsC,cAAc,EAAE;;AAEtD;EACE,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB","sourcesContent":[".DropDownModal-web-keyboard {\n  background-color: #fff;\n  z-index: 1;\n  overflow: scroll;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;\n  outline: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-radius: 10px 10px 10px 10px;\n  height: calc(100vh - 1.5rem);\n  overflow: scroll;\n}\n\n.dark .DropDownModal-web-keyboard {\n  background-color: var(--dark-blue);\n  color: rgb(255, 255, 255) !important;\n}\n\n.search-bar-no-result {\n  padding: 16px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n/* ── Unified empty / default state ────────────────────────── */\n.kbd-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  padding: 48px 32px;\n  text-align: center;\n  width: 100%;\n  flex: 1;\n}\n\n.kbd-empty-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 4px;\n}\n.kbd-empty-icon--scan {\n  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);\n  color: #2a71ff;\n  box-shadow: 0 6px 24px rgba(42, 113, 255, 0.15);\n}\n.kbd-empty-icon--search {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  color: #94a3b8;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);\n}\n\n.kbd-empty-heading {\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0;\n  letter-spacing: -0.01em;\n}\n.kbd-empty-sub {\n  font-size: 12.5px;\n  color: #94a3b8;\n  margin: 0;\n  max-width: 260px;\n}\n\n.kbd-empty-hints {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  justify-content: center;\n  margin-top: 6px;\n}\n.kbd-empty-hint-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 5px 12px;\n  border-radius: 999px;\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #475569;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n}\n\n/* dark mode */\n.dark .kbd-empty-icon--scan  { background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%); color: #93c5fd; }\n.dark .kbd-empty-icon--search { background: #1e293b; color: #475569; }\n.dark .kbd-empty-heading { color: #e2e8f0; }\n.dark .kbd-empty-sub    { color: #475569; }\n.dark .kbd-empty-hint-chip { background: #1e293b; border-color: #334155; color: #64748b; }\n\n.dark .drop-down-modal-bg {\n  padding: 0 !important;\n  background-color: var(--dark-blue);\n}\n\n\n.drop-down-modal-bg {\n  padding: 0 !important;\n}\n\n.popular-search-head {\n  font-weight: bold;\n  background-color: white !important;\n}\n\n.dark .popular-search-head {\n  background-color: var(--dark-blue) !important;\n}\n\n.recent-search-inner-details {\n  text-align: left !important;\n  font-size: 0.9rem !important;\n  overflow-wrap: break-word;\n  overflow: hidden;\n  white-space: nowrap;\n  transition: all 0.5s ease;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.recent-search-mrp {\n  font-size: 1rem !important;\n  font-weight: bold !important;\n}\n\n.info-icon-box {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  padding: 1rem;\n  margin-right: 1rem !important;\n  height: 30px;\n  gap: 1rem;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.popular-search-reult-found {\n  color: #0563fb;\n  font-size: 1.3rem !important;\n  font-weight: bold !important;\n}\n\n/* ── Top Searches ── */\n.top-searches-title {\n  font-size: 13px;\n  font-weight: 700;\n  color: #2a71ff;\n  margin-bottom: 14px;\n  text-align: left;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n}\n\n/* Horizontal scrolling row */\n.top-searches-container {\n  display: flex;\n  flex-direction: row;\n  gap: 12px;\n  overflow-x: auto;\n  padding-bottom: 8px;\n  scrollbar-width: none;\n}\n.top-searches-container::-webkit-scrollbar {\n  display: none;\n}\n\n/* Image-first card */\n.top-search-card {\n  flex: 0 0 128px;\n  width: 128px;\n  border-radius: 18px;\n  border: 1px solid #e2e8f0;\n  background-color: #ffffff;\n  padding: 14px 10px 12px;\n  text-align: center;\n  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.06);\n  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n.dark .top-search-card {\n  background-color: var(--dark-blue);\n  border-color: #334155;\n}\n.top-search-card:hover,\n.top-search-card:focus {\n  transform: translateY(-3px);\n  box-shadow: 0 12px 28px rgba(42, 113, 255, 0.14);\n  border-color: rgba(42, 113, 255, 0.4);\n  outline: none;\n}\n.top-search-card:disabled {\n  opacity: 0.7;\n  cursor: wait;\n  transform: none;\n}\n\n/* Image wrapper (circle) */\n.top-search-card-img-wrap {\n  position: relative;\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 2px solid #e2e8f0;\n  flex-shrink: 0;\n  background: #f1f5f9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.top-search-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.top-search-card-avatar {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  font-size: 24px;\n  font-weight: 800;\n  border-radius: 50%;\n}\n.top-search-card-loader-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.35);\n  border-radius: 50%;\n}\n\n/* Product name */\n.top-search-card-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: #0f172a;\n  margin: 0;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.4;\n  width: 100%;\n}\n.dark .top-search-card-title {\n  color: #f1f5f9;\n}\n\n/* Price row */\n.top-search-card-price {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  width: 100%;\n}\n.top-search-card-mrp {\n  font-size: 10px;\n  color: #94a3b8;\n  text-decoration: line-through;\n}\n.dark .top-search-card-mrp {\n  color: #64748b;\n}\n.top-search-card-sp {\n  font-size: 12px;\n  color: #2a71ff;\n  font-weight: 700;\n}\n\n.drawer-dropdown-override {\n  background-color: transparent !important;\n  box-shadow: none !important;\n  height: auto !important;\n  overflow: visible !important;\n  padding: 0;\n  border-radius: 0;\n  width: 100% !important;\n  display: block !important;\n}\n\n.dark .drawer-dropdown-override {\n  background-color: transparent !important;\n}\n\n/* Product Search Results Styles */\n.product-search-results-heading {\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #2a71ff;\n}\n\n.product-search-results-info-icon {\n  display: flex;\n  height: 20px;\n  width: 20px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background-color: #dbeafe;\n  color: #2a71ff;\n  font-size: 11px;\n}\n\n.product-search-results-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.product-search-card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  border-radius: 22px;\n  border: 1px solid #e2e8f0;\n  padding: 12px 16px;\n  box-shadow: 0 14px 32px rgba(15, 23, 42, 0.05);\n  transition: all 0.2s ease;\n  background-color: white;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.product-search-card:hover {\n  border-color: #cbd5e1;\n}\n\n/* Highlight the whole row when its ADD button is keyboard-focused */\n.product-search-card:has(.product-search-add-btn:focus-visible) {\n  border-color: #2a71ff;\n  background-color: #f0f5ff;\n  box-shadow: 0 0 0 2px rgba(42, 113, 255, 0.15);\n}\n\n/* For products without inventory */\n.product-search-card.scale-card {\n  border-color: #fecdd3;\n  background-color: rgba(254, 242, 242, 0.7);\n}\n\n/* ── Clickable area (image + details) in search results — opens product detail drawer ── */\n.ps-clickable-body {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex: 1;\n  min-width: 0;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n  border-radius: 12px;\n  transition: background 0.15s;\n}\n.ps-clickable-body:hover {\n  background: rgba(42, 113, 255, 0.06);\n}\n.ps-clickable-body:hover .product-search-name {\n  color: #2a71ff;\n}\n.ps-clickable-body:focus-visible {\n  outline: 2px solid #2a71ff;\n  outline-offset: 2px;\n}\n.dark .ps-clickable-body:hover {\n  background: rgba(42, 113, 255, 0.1);\n}\n\n.product-search-image-container {\n  height: 56px;\n  width: 56px;\n  flex-shrink: 0;\n  overflow: hidden;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background-color: #f8fafc;\n}\n\n.product-search-image {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n}\n\n.product-search-details {\n  min-width: 0;\n  flex: 1;\n  text-align: left;\n}\n\n.product-search-title-row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.product-search-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0f172a;\n  margin: 0;\n}\n\n.dark .product-search-name {\n  color: #f1f5f9;\n}\n\n/* Out-of-stock but eligible to sell */\n.product-search-badge-oos {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border-radius: 9999px;\n  background-color: #fff7ed;\n  border: 1px solid #fed7aa;\n  padding: 4px 8px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #c2410c;\n  line-height: 1;\n  white-space: nowrap;\n}\n.dark .product-search-badge-oos {\n  background-color: #431407;\n  border-color: #7c2d12;\n  color: #fb923c;\n}\n\n.product-search-badge-batches {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border-radius: 9999px;\n  background-color: #d1fae5;\n  padding: 4px 8px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: #065f46;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.dark .product-search-badge-batches {\n  background-color: #064e3b;\n  color: #6ee7b7;\n}\n\n.product-search-badge-scale {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  border-radius: 9999px;\n  background-color: #eff6ff;\n  padding: 4px 8px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #2a71ff;\n  line-height: 1;\n}\n\n.product-search-badge-weight-unit {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 9999px;\n  background-color: #ecfdf5;\n  padding: 4px 8px;\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n  color: #059669;\n  line-height: 1;\n}\n\n.dark .product-search-badge-weight-unit {\n  background-color: #064e3b;\n  color: #6ee7b7;\n}\n\n.product-search-scale-icon {\n  height: 12px;\n  width: 12px;\n}\n\n.product-search-barcode {\n  margin-top: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  color: #2a71ff;\n  margin-bottom: 0;\n}\n\n.product-search-price-col {\n  min-width: 72px;\n  text-align: right;\n}\n\n.product-search-price {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 2px;\n  margin: 0;\n}\n\n.product-search-mrp {\n  font-size: 12px;\n  color: #64748b;\n  font-weight: 500;\n}\n\n.product-search-sp {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2a71ff;\n}\n\n.product-search-add-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n  border: 1px solid transparent;\n  min-height: 36px;\n  height: 40px;\n  border-radius: 12px;\n  padding: 8px 16px;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.12em;\n  color: white;\n  cursor: pointer;\n  background-color: #2a71ff;\n  box-shadow: 0 14px 24px rgba(42, 113, 255, 0.24);\n  outline: none;\n}\n\n.product-search-add-btn:hover {\n  background-color: #1f63ea;\n}\n\n/* Keyboard-focus ring — visible only when navigating with Tab, not on mouse click */\n.product-search-add-btn:focus-visible {\n  background-color: #1a5ce0;\n  outline: 2.5px solid #ffffff;\n  outline-offset: 2px;\n  box-shadow:\n    0 0 0 5px rgba(42, 113, 255, 0.45),\n    0 14px 24px rgba(42, 113, 255, 0.28);\n  transform: scale(1.04);\n}\n\n.product-search-add-btn.scale-btn {\n  background-color: #e11d48;\n  box-shadow: 0 14px 24px rgba(225, 29, 72, 0.24);\n}\n\n.product-search-add-btn.scale-btn:hover,\n.product-search-add-btn.scale-btn:focus {\n  background-color: #be123c;\n}\n\n/* No-inventory button — muted, non-interactive */\n.product-search-add-btn.no-inventory-btn {\n  background-color: #f1f5f9;\n  color: #94a3b8;\n  box-shadow: none;\n  cursor: not-allowed;\n  border: 1.5px solid #e2e8f0;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 11px;\n  letter-spacing: 0.08em;\n}\n.product-search-add-btn.no-inventory-btn:hover,\n.product-search-add-btn.no-inventory-btn:focus {\n  background-color: #f1f5f9;\n  color: #94a3b8;\n}\n\n/* No-inventory badge in title row */\n.product-search-badge-no-inventory {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  border-radius: 9999px;\n  background-color: #fef2f2;\n  padding: 3px 8px;\n  font-size: 9.5px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  color: #dc2626;\n  border: 1px solid #fecaca;\n  line-height: 1;\n}\n\n/* Discounted price styles */\n.product-search-mrp--disc {\n  text-decoration: line-through;\n  color: #94a3b8;\n  font-size: 11px;\n}\n.product-search-sp--highlight {\n  font-size: 15px;\n  font-weight: 700;\n  color: #16a34a;\n}\n\n/* Avatar letter for products without image */\n.ps-avatar-letter {\n  font-size: 22px;\n  font-weight: 800;\n  color: rgba(255, 255, 255, 0.9);\n  line-height: 1;\n  user-select: none;\n}\n\n/* Dark mode additions */\n.dark .product-search-badge-no-inventory {\n  background-color: rgba(220, 38, 38, 0.12);\n  border-color: rgba(220, 38, 38, 0.3);\n  color: #f87171;\n}\n.dark .product-search-add-btn.no-inventory-btn {\n  background-color: #1e293b;\n  color: #475569;\n  border-color: #334155;\n}\n.dark .product-search-sp--highlight { color: #4ade80; }\n\n.dark .product-search-card {\n  background-color: var(--dark-blue);\n  border-color: #334155;\n}\n\n.dark .product-search-card.scale-card {\n  background-color: rgba(244, 63, 94, 0.1);\n  border-color: #fb7185;\n}\n\n.dark .product-search-card:hover,\n.dark .product-search-card:focus-within {\n  border-color: #475569;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
